/**
 * Shared KPI currency formatter.
 * - Numbers up to $99,999 are shown in full (e.g., "$17,000", "$99,999")
 * - From $100,000 onwards, we switch to compact K notation (e.g., "$125K")
 * - From $1,000,000 onwards, we use M notation (e.g., "$1.5M")
 */
export const fmtKPI = (v) => {
  if (v === null || v === undefined || Number.isNaN(v)) return '$0';
  const n = Number(v);
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 100_000) return `$${Math.round(n / 1000)}K`;
  return `$${Math.round(n).toLocaleString()}`;
};

/**
 * Lightweight non-currency formatter — same thresholds without the $ prefix.
 */
export const fmtKPINumber = (v) => {
  if (v === null || v === undefined || Number.isNaN(v)) return '0';
  const n = Number(v);
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`;
  if (n >= 100_000) return `${Math.round(n / 1000)}K`;
  return Math.round(n).toLocaleString();
};
